/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { GetMonitorQueryResponse, GetMonitorPathParams, GetMonitor401, GetMonitor404 } from '../types/GetMonitor.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetMonitorUrl(id: GetMonitorPathParams['id']) {
  const res = { method: 'GET', url: `/v1/monitors/${id}` as const };
  return res;
}

/**
 * @summary Get monitor by ID
 * {@link /v1/monitors/:id}
 */
export async function getMonitor(id: GetMonitorPathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetMonitorQueryResponse, ResponseErrorConfig<GetMonitor401 | GetMonitor404>, unknown>({
    method: 'GET',
    url: getGetMonitorUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
